import Count from "@/common/count";
import Link from "@/components/common/Link";
import Image from "@/components/common/Image";
import { useI18n } from "@/common/I18nProvider";
import project_data from "@/data/projects-data";

export default function AboutStory() {
  const { messages } = useI18n();
  const story = messages.about.page.story;
  const stats = story.stats;
  
  // Get first 4 project images
  const projectImages = project_data.slice(0, 4);

  return (
    <section className="story-section">
      {/* <!-- Divider --> */}
      <div className="divider"></div>

      <div className="container">
        <div className="story-content">
          <div className="row g-4 align-items-end">
            <div className="col-12 col-lg-8 col-xxl-9">
              <div className="section-heading text-white">
                <h2 className="mb-3 text-white">{story.title}</h2>
                <p className="mb-5 text-white">{story.description}</p>
              </div>

              <div className="row g-4 align-items-end">
                <div className="col-12 col-md-6">
                  {/* <!-- About List --> */}
                  <ul className="about-list list-unstyled text-white">
                    <li className="text-white">
                      <svg width="20" height="20" fill="#ffffff">
                        <use href="#checkIcon3"></use>
                      </svg>
                      {story.features.item1}
                    </li>
                    <li className="text-white">
                      <svg width="20" height="20" fill="#ffffff">
                        <use href="#checkIcon3"></use>
                      </svg>
                      {story.features.item2}
                    </li>
                    <li className="text-white">
                      <svg width="20" height="20" fill="#ffffff">
                        <use href="#checkIcon3"></use>
                      </svg>
                      {story.features.item3}
                    </li>
                    <li className="text-white">
                      <svg width="20" height="20" fill="#ffffff">
                        <use href="#checkIcon3"></use>
                      </svg>
                      {story.features.item4}
                    </li>
                    <li className="text-white">
                      <svg width="20" height="20" fill="#ffffff">
                        <use href="#checkIcon3"></use>
                      </svg>
                      {story.features.item5}
                    </li>
                  </ul>
                  <div className="divider-sm"></div>
                  {/* <!-- Button --> */}
                  <Link href="/contact" className="btn btn-primary">
                    <span>{story.bookConsultation} <i className="ti ti-arrow-up-right"></i></span>
                    <span>{story.bookConsultation} <i className="ti ti-arrow-up-right"></i></span>
                  </Link>
                </div>
                <div className="col-12 col-md-6">
                  <div className="story-main-image">
                    <Image
                      src={projectImages[0]?.image || "/assets/img/bg-img/new-product.jpeg"}
                      alt={projectImages[0]?.title || ""}
                      className="w-100 h-auto"
                      width={1920}
                      height={1080}
                      priority
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-4 col-xxl-3">
              <div className="story-images-grid">
                {projectImages.slice(1, 3).map((project, index) => (
                  <div key={project.id} className="story-image-item">
                    <Image
                      src={project.image}
                      alt={project.title}
                      className="w-100 h-auto"
                      width={1920}
                      height={1080}
                      priority={index === 0}
                    />
                    <div className="story-image-overlay">
                      <span className="story-image-badge">{project.categories}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="divider"></div>

          {/* <!-- Projects Gallery --> */}
          <div className="projects-gallery-section">
            <div className="section-heading text-center mb-5">
              <h2 className="mb-3">{story.galleryTitle}</h2>
              <p className="text-muted">{story.galleryDescription}</p>
            </div>
            <div className="row g-4">
              {project_data.map((project) => (
                <div key={project.id} className="col-12 col-sm-6 col-md-4 col-lg-3">
                  <div className="project-gallery-item">
                    <div className="project-gallery-image">
                      <Image
                        src={project.image}
                        alt={project.title}
                        className="w-100 h-auto"
                        width={613}
                        height={400}
                        priority={project.id <= 2}
                      />
                      <div className="project-gallery-overlay">
                        <div className="project-gallery-content">
                          <span className="project-gallery-badge">{project.categories}</span>
                          <h6 className="project-gallery-title">{project.title}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="divider"></div>

          {/* <!-- Cool Facts Wrap --> */}
          <div className="cool-facts-wrap improved-stats">
            <div className="row g-4">
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="cool-facts stat-card">
                  <div className="stat-icon">
                    <i className="ti ti-calendar-time"></i>
                  </div>
                  <h2 className="mb-2"><span className="counter"><Count number={5} text="+" add_style={true} /> </span></h2>
                  <p className="mb-0">{stats.years}</p>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="cool-facts stat-card">
                  <div className="stat-icon">
                    <i className="ti ti-checkbox"></i>
                  </div>
                  <h2 className="mb-2"><span className="counter"><Count number={430} text="+" add_style={true} /> </span></h2>
                  <p className="mb-0">{stats.projects}</p>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="cool-facts stat-card">
                  <div className="stat-icon">
                    <i className="ti ti-users"></i>
                  </div>
                  <h2 className="mb-2"><span className="counter"><Count number={2} text="+" add_style={true} /> </span></h2>
                  <p className="mb-0">{stats.employees}</p>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="cool-facts stat-card">
                  <div className="stat-icon">
                    <i className="ti ti-world"></i>
                  </div>
                  <h2 className="mb-2"><span className="counter"><Count number={10} text="+" add_style={true} /> </span></h2>
                  <p className="mb-0">{stats.customers}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Divider --> */}
      <div className="divider"></div>
    </section>
  )
}